import { Selector } from '../../lib/generated/zeus';
import { noteContentSelector } from './note';

export const shiftEventSelector = Selector('ShiftEvent')({
  shiftId: true,
  shiftEvent: true,
  eventCreatedAt: true,
  eventCreatedBy: true,
  shiftStartTime: true,
  shiftEndTime: true,
  shiftStatus: true,
  shiftNotes: noteContentSelector,
  shiftIsRecurring: true,
  shiftRecurrencePattern: true,
  shiftRecurrenceEndDate: true,
  username: true,
  userEmail: true,
  userFirstName: true,
  userLastName: true,
  userEmploymentType: true,
  roleName: true,
  roleGroup: true,
  teamName: true,
  teamType: true,
  teamIon: true,
});
